/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_Enable_LabelInputs */



/**
* | output |
* | --- |
* | "Enable BWF Metadata" |
*
* @param {Audio_Description_Export_Bwf_Enable_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_enable_label = /** @type {((inputs?: Audio_Description_Export_Bwf_Enable_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_Enable_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer les métadonnées BWF")
	if (locale === "de") return /** @type {LocalizedString} */ ("BWF-Metadaten aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita metadati BWF")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить метаданные BWF")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar metadatos BWF")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用 BWF 元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("BWFメタデータを有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("BWF मेटाडेटा सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar metadados BWF")
	return /** @type {LocalizedString} */ ("Enable BWF Metadata")
});